var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.6581,
    fill: "white",
    stroke: "#EBF4FF",
    strokeWidth: 0.683761
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.341,
    cy: 40.3429,
    r: 28.7179,
    fill: "url(#paint0_linear_9420_10632)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0859 41.1012L35.6266 46.6419C35.9233 46.9386 36.4043 46.9386 36.701 46.6419L49.839 33.5039",
    stroke: "white",
    strokeWidth: 4.5584,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9420_10632",
    x1: 60.1701,
    y1: 5.47116,
    x2: 20.5119,
    y2: 106.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66F3AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.8757dbe2e11977c1fb95c56f9ebc5fba.svg";
export { ForwardRef as ReactComponent };